import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmDiscountType {
    DiscountTypeID:   number;
    DiscountTypeName: string;

    constructor(
         pDiscountTypeID:   number
        ,pDiscountTypeName: string
    ) {
        this.DiscountTypeID   = pDiscountTypeID;
        this.DiscountTypeName = pDiscountTypeName;
    }
}

export class dmOfferType {
    OfferType:           RQService.Pms.GetOfferTypesRow;

    IsSelected:          boolean;
    HasLiveData:         boolean;

    SourceOfferTypeName: string;
    DiscountTypeName:    string;
    DiscountDescription: string;

    constructor(
        pOfferType: RQService.Pms.GetOfferTypesRow
    ) {
        this.OfferType           = pOfferType;
        this.IsSelected          = false;
        this.HasLiveData         = false;
        this.SourceOfferTypeName = '';
        this.DiscountTypeName    = '';
        this.DiscountDescription = '';
    }
}

export class OfferTypesViewModel {
    ShowAlert:                   (pTitle: string, pMessage: string)                      => void;
    ShowConfirmation:            (pTitle: string, pMessage: string, pAction: () => void) => void;
    BackToSignIn:                ()                                                      => void;
    NewLoading:                  (pMessage: string)                                      => dmLoading;

    mlText:                      MLText;
    app:                         mlBroker;
    ml:                          mlBroker;
    Hotel:                       dmHotel;
    LangID:                      number;
                            
    InAction:                    boolean;
                           
    SelectedLangID:              number;
    SelectedLangCode:            string;
    SelectedOfferTypeID:         number;
    SelectedNameInViewLang:      string;
    SelectedOfferTypeName:       string;
    SelectedNameStored:          string;

    HasSelectedOfferType:        boolean;
    WithFreeText:                boolean;
    SelectedOTHasLiveData:       boolean;

    SelectedPaymentSchemeID:     number;
    SelectedOfferTypeAutoNameID: number;
    AddHasFreeText:              boolean;
    AddNameEn:                   string;

    PackageLevelAdvanceDays:     number;

    PaymentSchemes:              RQService.Pms.GetPaymentSchemesOTARow[];
    OfferTypeAutoNames:          RQService.Pms.GetOfferTypeAutoNamesRow[];
    OfferTypes:                  dmOfferType[];
    OfferTypesByID:              dmOfferType[];
    Languages:                   RQService.Pms.GetLanguagesRow[];

    /* Non-Ref easy activation properties */
    SelectedSourceOfferTypeID:   number;
    DiscountTypeID:              number;

    IsSurcharge:                 boolean;
    IsSurchargeLabel:            string;

    Surcharge:                   number;
    SourceMLOS:                  boolean;
    SourceMaxStay:               boolean;
    SourceNoArr:                 boolean;
    SourceNoDep:                 boolean;

    SourceOfferTypes:            dmOfferType[];
    SourceOfferTypesByID:        dmOfferType[];
    DiscountTypes:               dmDiscountType[];
    DiscountTypesByID:           dmDiscountType[];

    ShowAdvanced:                boolean;

    EasyNonRefFocused:           boolean;
    EasyNonRefSelected:          boolean;
    EasyNonRefActive:            boolean;
    EasyNonRefOfferTypeID:       number;

    /* Early-Bird easy activation properties */
    EBSelectedSourceOfferTypeID: number;
    EBDiscountTypeID:            number;

    EBIsSurcharge:               boolean;
    EBIsSurchargeLabel:          string;

    EBSurcharge:                 number;
    EBSourceMLOS:                boolean;
    EBSourceMaxStay:             boolean;
    EBSourceNoArr:               boolean;
    EBSourceNoDep:               boolean;

    EBSourceOfferTypes:          dmOfferType[];
    EBSourceOfferTypesByID:      dmOfferType[];
    EBDiscountTypes:             dmDiscountType[];
    EBDiscountTypesByID:         dmDiscountType[];

    EBShowAdvanced:              boolean;

    EarlyBirdFocused:            boolean;
    EarlyBirdSelected:           boolean;
    EarlyBirdActive:             boolean;
    EarlyBirdOfferTypeID:        number;

    EarlyBirdAdvanceDays:        number;

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                                        => void
        ,pShowAlert:        (pTitle:   string ,pMessage: string)                      => void
        ,pNewLoading:       (pMessage: string)                                        => dmLoading
        ,pShowConfirmation: (pTitle:   string ,pMessage: string ,pAction: () => void) => void
    ) {
        this.mlText                      = pMLText;
        this.LangID                      = this.mlText.GetLangID();
        this.app                         = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                          = this.mlText.GetBroker(
            'HotelAreaOfferTypes'
        );

        this.Hotel                       = pHotel;
        this.BackToSignIn                = pBackToSignIn;
        this.ShowAlert                   = pShowAlert;
        this.ShowConfirmation            = pShowConfirmation;
        this.NewLoading                  = pNewLoading;

        this.InAction                    = true;
                                  
        this.SelectedLangID              = 1;
        this.SelectedLangCode            = 'en';
        this.SelectedOfferTypeID         = 0;
        this.SelectedNameInViewLang      = this.ml.Text(
             'NoRatePackageSelectedWithBrackets'
            ,'(No rate package selected)'
        );
        this.SelectedOfferTypeName       = '';
        this.SelectedNameStored          = '';

        this.HasSelectedOfferType        = false;
        this.WithFreeText                = false;
        this.SelectedOTHasLiveData       = false;

        this.SelectedPaymentSchemeID     = 0;
        this.SelectedOfferTypeAutoNameID = 0;

        this.AddHasFreeText              = false;
        this.AddNameEn                   = '';

        this.PackageLevelAdvanceDays     = 0;

        this.PaymentSchemes              = [];
        this.OfferTypeAutoNames          = [];
        this.OfferTypes                  = [];
        this.OfferTypesByID              = [];
        this.Languages                   = [];

        /* Non-Ref easy activation properties */
        this.SelectedSourceOfferTypeID   = 0;
        this.DiscountTypeID              = 0;

        this.IsSurcharge                 = false;
        this.IsSurchargeLabel            = this.ml.Text('DiscountAmount' ,'Discount Amount');

        this.Surcharge                   = 0;
        this.SourceMLOS                  = true;
        this.SourceMaxStay               = false;
        this.SourceNoArr                 = false;
        this.SourceNoDep                 = false;

        this.SourceOfferTypes            = [];
        this.SourceOfferTypesByID        = [];
        this.DiscountTypes               = [];
        this.DiscountTypesByID           = [];

        let percentageType: dmDiscountType = new dmDiscountType(
             0
            ,this.ml.Text('PercentageModifier'  ,'Percentage Modifier')
        );

        let fixedType:      dmDiscountType = new dmDiscountType(
             1
            ,this.ml.Text('FixedPricePerPerson' ,'Fixed Price Per Person')
        );

        this.DiscountTypes.push(percentageType);
        this.DiscountTypes.push(fixedType);

        this.DiscountTypesByID[0] = percentageType;
        this.DiscountTypesByID[1] = fixedType;

        /* Early-Bird easy activation properties */
        this.EBSelectedSourceOfferTypeID = 0;
        this.EBDiscountTypeID            = 0;

        this.EBIsSurcharge               = false;
        this.EBIsSurchargeLabel          = this.ml.Text('DiscountAmount' ,'Discount Amount');

        this.EBSurcharge                 = 0;
        this.EBSourceMLOS                = true;
        this.EBSourceMaxStay             = false;
        this.EBSourceNoArr               = false;
        this.EBSourceNoDep               = false;

        this.EBSourceOfferTypes          = [];
        this.EBSourceOfferTypesByID      = [];
        this.EBDiscountTypes             = [];
        this.EBDiscountTypesByID         = [];

        let ebPercentageType: dmDiscountType = new dmDiscountType(
             0
            ,this.ml.Text('PercentageModifier'  ,'Percentage Modifier')
        );

        let ebFixedType:      dmDiscountType = new dmDiscountType(
             1
            ,this.ml.Text('FixedPricePerPerson' ,'Fixed Price Per Person')
        );

        this.EBDiscountTypes.push(ebPercentageType);
        this.EBDiscountTypes.push(ebFixedType);

        this.EBDiscountTypesByID[0] = percentageType;
        this.EBDiscountTypesByID[1] = fixedType;

        this.EarlyBirdAdvanceDays   = 28;

        let loading                      = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let paymentSchemeParams = RQParam.PmsGetPaymentSchemesOTAParams();

            paymentSchemeParams.LangID = this.LangID;

            RQService.Pms.GetPaymentSchemesOTA(paymentSchemeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let paymentSchemes = response.RQueryResult;

                for (let i = 0; i < paymentSchemes.length; i++) {
                    let paymentScheme = RQService.Pms.PopulateGetPaymentSchemesOTARow(
                        paymentSchemes[i]
                    );
            
                    console.log('row push');
            
                    this.PaymentSchemes.push(paymentScheme);
                }

                let autoNameParams = RQParam.PmsGetOfferTypeAutoNamesParams();

                autoNameParams.LangID = this.LangID

                RQService.Pms.GetOfferTypeAutoNames(autoNameParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let autoNames = response.RQueryResult;

                    for (let i = 0; i < autoNames.length; i++) {
                        let autoName = RQService.Pms.PopulateGetOfferTypeAutoNamesRow(
                            autoNames[i]
                        );
            
                        console.log('row push');
            
                        this.OfferTypeAutoNames.push(autoName);
                    }

                    RQService.Pms.GetLanguages(
                        {}
                    ).then((result) => {
                        let response = result as any;
            
                        if (response.HasErrorOrException) { loading.Dismiss(); return; }
            
                        let languages = response.RQueryResult;
            
                        for (let i = 0; i < languages.length; i++) {
                            let language = RQService.Pms.PopulateGetLanguagesRow(
                                languages[i]
                            );
            
                            console.log('row push');
            
                            this.Languages.push(language);
                        }

                        let easyNonRefParams = RQParam.PmsGetEasyNonRefOfferTypeParams();

                        easyNonRefParams.HotelID = this.Hotel.HotelID;
                        easyNonRefParams.LangID  = this.LangID;

                        RQService.Pms.GetEasyNonRefOfferType(easyNonRefParams).then((result) => {
                            let response = result as any;

                            if (response.HasErrorOrException) { loading.Dismiss(); return; }

                            let easyNonRefResult = response.RQueryResult;

                            if (easyNonRefResult.length > 0) {
                                let easyNonRef = RQService.Pms.PopulateGetEasyNonRefOfferTypeRow(
                                    easyNonRefResult[0]
                                );

                                this.EasyNonRefActive          = true;
                                this.EasyNonRefOfferTypeID     = easyNonRef.OfferTypeID;

                                this.SelectedSourceOfferTypeID = easyNonRef.SourceOfferTypeID;
                                this.DiscountTypeID            = easyNonRef.DiscountTypeID;

                                this.IsSurcharge               = (easyNonRef.Surcharge > 0);

                                if (this.IsSurcharge) {
                                    this.IsSurchargeLabel = this.ml.Text(
                                         'SurchargeAmount'
                                        ,'Surcharge Amount'
                                    );
                                } else {
                                    this.IsSurchargeLabel = this.ml.Text(
                                         'DiscountAmount'
                                        ,'Discount Amount'
                                    );
                                }

                                this.Surcharge     = (this.IsSurcharge)
                                                   ? (easyNonRef.Surcharge)
                                                   : ((-1) * easyNonRef.Surcharge);

                                this.SourceMLOS    = (easyNonRef.SourceMLOS    != 0);
                                this.SourceMaxStay = (easyNonRef.SourceMaxStay != 0);
                                this.SourceNoArr   = (easyNonRef.SourceNoArr   != 0);
                                this.SourceNoDep   = (easyNonRef.SourceNoDep   != 0);
                            } else {
                                if (this.SourceOfferTypes.length == 1) {
                                    this.SelectSourceOfferType(
                                        this.SourceOfferTypes[0].OfferType.OfferTypeID
                                    );
                                }

                                this.EasyNonRefActive      = false;
                                this.EasyNonRefOfferTypeID = 0;
                            }

                            let earlyBirdParams = RQParam.PmsGetEarlyBirdOfferTypeParams();

                            earlyBirdParams.HotelID = this.Hotel.HotelID;
                            earlyBirdParams.LangID  = this.LangID;

                            RQService.Pms.GetEarlyBirdOfferType(earlyBirdParams).then((result) => {
                                let response = result as any;

                                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                                let earlyBirdResult = response.RQueryResult;

                                if (earlyBirdResult.length > 0) {
                                    let earlyBird = RQService.Pms.PopulateGetEarlyBirdOfferTypeRow(
                                        earlyBirdResult[0]
                                    );

                                    this.EarlyBirdActive             = true;
                                    this.EarlyBirdOfferTypeID        = earlyBird.OfferTypeID;

                                    this.EBSelectedSourceOfferTypeID = earlyBird.SourceOfferTypeID;
                                    this.EBDiscountTypeID            = earlyBird.DiscountTypeID;

                                    this.EBIsSurcharge               = (earlyBird.Surcharge > 0);

                                    if (this.EBIsSurcharge) {
                                        this.EBIsSurchargeLabel = this.ml.Text(
                                             'SurchargeAmount'
                                            ,'Surcharge Amount'
                                        );
                                    } else {
                                        this.EBIsSurchargeLabel = this.ml.Text(
                                             'DiscountAmount'
                                            ,'Discount Amount'
                                        );
                                    }

                                    this.EBSurcharge     = (this.IsSurcharge)
                                                         ? (earlyBird.Surcharge)
                                                         : ((-1) * earlyBird.Surcharge);

                                    this.EBSourceMLOS    = (earlyBird.SourceMLOS    != 0);
                                    this.EBSourceMaxStay = (earlyBird.SourceMaxStay != 0);
                                    this.EBSourceNoArr   = (earlyBird.SourceNoArr   != 0);
                                    this.EBSourceNoDep   = (earlyBird.SourceNoDep   != 0);

                                    this.EarlyBirdAdvanceDays = earlyBird.PackageLevelAdvanceDays;
                                } else {
                                    if (this.EBSourceOfferTypes.length == 1) {
                                        this.EBSelectSourceOfferType(
                                            this.EBSourceOfferTypes[0].OfferType.OfferTypeID
                                        );
                                    }

                                    this.EarlyBirdActive      = false;
                                    this.EarlyBirdOfferTypeID = 0;
                                }

                                this.refreshOfferTypes(() => {
                                    loading.Dismiss();
            
                                    this.InAction = false;
                                });
                            });
                        });
                    });
                });
            });
        });
    }

    private refreshOfferTypes(pAction: () => void) {
        let offerTypesParams = RQParam.PmsGetOfferTypesParams();

        offerTypesParams.HotelID   = this.Hotel.HotelID;
        offerTypesParams.LangID    = this.LangID;

        this.OfferTypes.length     = 0;
        this.OfferTypesByID.length = 0;

        RQService.Pms.GetOfferTypes(offerTypesParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pAction(); return; }

            let offerTypes = response.RQueryResult;

            for (let i = 0; i < offerTypes.length; i++) {
                let offerType = new dmOfferType(
                    RQService.Pms.PopulateGetOfferTypesRow(
                        offerTypes[i]
                    )
                );

                if (offerType.OfferType.IsDiscountFilter == 0) {
                    console.log('row push');

                    this.OfferTypes.push(offerType);

                    this.OfferTypesByID[offerType.OfferType.OfferTypeID] = offerType;

                    this.SourceOfferTypes.push(offerType);

                    this.SourceOfferTypesByID[
                        offerType.OfferType.OfferTypeID
                    ] = offerType;

                    this.EBSourceOfferTypes.push(offerType);

                    this.EBSourceOfferTypesByID[
                        offerType.OfferType.OfferTypeID
                    ] = offerType;
                }
            }

            let cacheDataStatusParams     = RQParam.PmsCheckOfferTypeCacheDataStatusParams();

            cacheDataStatusParams.HotelID = this.Hotel.HotelID;

            RQService.Pms.CheckOfferTypeCacheDataStatus(cacheDataStatusParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { pAction(); return; }

                let offerTypeStatuses = response.RQueryResult;

                for (let i = 0; i < offerTypeStatuses.length; i++) {
                    let offerTypeStatus = RQService.Pms.PopulateCheckOfferTypeCacheDataStatusRow(
                        offerTypeStatuses[i]
                    );

                    if (this.OfferTypesByID[offerTypeStatus.OfferTypeID]) {
                        this.OfferTypesByID[offerTypeStatus.OfferTypeID].HasLiveData
                            = (offerTypeStatus.HasCacheData == 1);
                    }
                }

                if (this.OfferTypesByID[this.SelectedOfferTypeID]) {
                    this.selectOfferTypeInternal(
                         this.SelectedOfferTypeID
                        ,() => { pAction(); }
                    );
                } else {
                    this.HasSelectedOfferType   = false;
                    this.WithFreeText           = false;
                    this.SelectedOfferTypeID    = 0;
                    this.SelectedNameInViewLang = this.ml.Text(
                         'NoRatePackageSelectedWithBrackets'
                        ,'(No rate package selected)'
                    );
                    this.SelectedOfferTypeName  = '';
                    this.SelectedNameStored     = '';

                    this.SelectedOTHasLiveData  = false;

                    pAction();
                }
            });
        });
    }

    private selectOfferTypeInternal(pOfferTypeID: number, pAction: () => void) {
        if (!this.OfferTypesByID[pOfferTypeID]) {
            this.HasSelectedOfferType = false;
            this.WithFreeText         = false;
            this.SelectedOfferTypeID  = 0;

            for (let i: number = 0; i < this.OfferTypes.length; i++) {
                this.OfferTypes[i].IsSelected = false;
            }

            pAction();

            return;
        }

        this.SelectedOfferTypeID = pOfferTypeID;

        this.EasyNonRefFocused   = false;
        this.EasyNonRefSelected  = false;
        this.ShowAdvanced        = false;
        this.EarlyBirdFocused    = false;
        this.EarlyBirdSelected   = false;
        this.EBShowAdvanced      = false;

        let offerType: dmOfferType = this.OfferTypesByID[this.SelectedOfferTypeID];

        this.HasSelectedOfferType  = true;
        this.SelectedOTHasLiveData = offerType.HasLiveData;

        if (offerType.OfferType.OfferTypeAutoNameID > 0) { this.WithFreeText = false; }
        else                                             { this.WithFreeText = true;  }

        for (let i: number = 0; i < this.OfferTypes.length; i++) {
            if (offerType.OfferType.OfferTypeID == this.OfferTypes[i].OfferType.OfferTypeID) {
                this.OfferTypes[i].IsSelected = true;
            } else {
                this.OfferTypes[i].IsSelected = false;
            }
        }

        this.SelectedNameInViewLang = offerType.OfferType.OfferTypeName;

        if (this.SelectedLangID == this.LangID) {
            this.SelectedOfferTypeName = offerType.OfferType.OfferTypeName;
            this.SelectedNameStored    = this.SelectedOfferTypeName;

            pAction();
        } else {
            let offerTypeParams = RQParam.PmsGetOfferTypeParams();

            offerTypeParams.HotelID     = this.Hotel.HotelID;
            offerTypeParams.OfferTypeID = offerType.OfferType.OfferTypeID;
            offerTypeParams.LangID      = this.SelectedLangID;

            RQService.Pms.GetOfferType(offerTypeParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let roomTypeML = RQService.Pms.PopulateGetOfferTypeRow(
                    response.RQueryResult[0]
                )

                this.SelectedOfferTypeName = roomTypeML.OfferTypeName;
                this.SelectedNameStored    = this.SelectedOfferTypeName;

                pAction();
            });
        }
    }

    public SelectLanguage(pLangID: number) {
        if (this.InAction) { return; }

        this.SelectedLangID   = pLangID;
        this.SelectedLangCode = this.Languages[(pLangID - 1)].LangISOCode;

        if (this.SelectedOfferTypeID != 0) {
            this.InAction = true;

            let loading   = this.NewLoading(
                this.app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                this.selectOfferTypeInternal(
                     this.SelectedOfferTypeID
                    ,() => {
                        loading.Dismiss();
                
                        this.InAction = false;
                    }
                );
            });
        }
    }

    public SelectOfferType(pOfferTypeID: number) {
        if (this.InAction) { return; }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.selectOfferTypeInternal(
                 pOfferTypeID
                ,() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                }
            );
        });
    }

    public SelectOfferTypeAutoName(pOfferTypeAutoNameID: number) {
        this.SelectedOfferTypeAutoNameID = pOfferTypeAutoNameID;
        this.PackageLevelAdvanceDays     = 0;

        if (pOfferTypeAutoNameID == 5) { this.PackageLevelAdvanceDays = 28; }

        for (let i: number = 0; i < this.OfferTypeAutoNames.length; i++) {
            let name = this.OfferTypeAutoNames[i];

            if (name.OfferTypeAutoNameID == pOfferTypeAutoNameID) {
                this.SelectedPaymentSchemeID = name.PaymentSchemeID;
            }
        }
    }

    public SelectPaymentScheme(pPaymentSchemeID: number) {
        this.SelectedPaymentSchemeID = pPaymentSchemeID;
    }

    public SyncPaymentScheme() {
        if (!this.AddHasFreeText)
        {
            for (let i: number = 0; i < this.OfferTypeAutoNames.length; i++) {
                let name = this.OfferTypeAutoNames[i];

                if (name.OfferTypeAutoNameID == this.SelectedOfferTypeAutoNameID) {
                    this.SelectedPaymentSchemeID = name.PaymentSchemeID;
                }
            }
        } else {
            this.SelectedPaymentSchemeID = this.PaymentSchemes[0].PaymentSchemeID;
            this.PackageLevelAdvanceDays = 0;
        }
    }

    public AddOfferType() {
        if (this.InAction) { return; }

        if (this.AddHasFreeText && this.AddNameEn == '') {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddOfferType'
                    ,'Cannot Add Rate Package'
                )
                ,this.ml.Text(
                     'OfferTypeNameEmpty'
                    ,'Rate package name cannot be empty'
                )
            );

            return;
        }

        if ((!this.AddHasFreeText) && (this.SelectedOfferTypeAutoNameID == 0)) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddOfferType'
                    ,'Cannot Add Rate Package'
                )
                ,this.ml.Text(
                     'NoRatePackageNameSelected'
                    ,'No rate package name selected'
                )
            );

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        if (this.AddHasFreeText) { this.PackageLevelAdvanceDays = 0; }

        loading.Show(() => {
            let addParams = RQParam.PmsNewOfferTypeOTAParams();
            
            addParams.HotelID                 = this.Hotel.HotelID;
            addParams.PaymentSchemeID         = this.SelectedPaymentSchemeID;
            addParams.OfferTypeName           = this.AddNameEn;
            addParams.OfferTypeAutoNameID
                = (this.AddHasFreeText)
                ? 0
                : this.SelectedOfferTypeAutoNameID;

            addParams.PackageLevelAdvanceDays = this.PackageLevelAdvanceDays;
            addParams.LangID                  = this.LangID;

            RQService.Pms.NewOfferTypeOTA(addParams).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) {
                    loading.Dismiss();
            
                    this.InAction = false;
            
                    return;
                }

                let newOfferTypeID: number = 0;

                let status = response.RQueryResult;

                if (
                    (status.length > 0)
                &&  (status[0].ReturnValue)
                &&  (!isNaN(Number(status[0].ReturnValue)))
                ) {
                    newOfferTypeID = Number(status[0].ReturnValue);
                }

                this.SelectedPaymentSchemeID     = 0;
                this.SelectedOfferTypeAutoNameID = 0;
            
                this.AddHasFreeText              = false;
                this.AddNameEn                   = '';
            
                this.refreshOfferTypes(() => {
                    this.selectOfferTypeInternal(
                         newOfferTypeID
                        ,() => {
                            loading.Dismiss();
            
                            this.InAction = false;
                        }
                    );
                });
            });
        });
    }

    private deleteOfferTypeInternal(pOfferTypeID: number): void {
        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let offerType: dmOfferType = this.OfferTypesByID[pOfferTypeID];
            
            let deleteParams = RQParam.PmsDeleteOfferTypeParams();
            
            deleteParams.HotelID     = this.Hotel.HotelID;
            deleteParams.OfferTypeID = offerType.OfferType.OfferTypeID;
            deleteParams.LangID      = this.LangID;
            
            RQService.Pms.DeleteOfferType(deleteParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshOfferTypes(() => {
                    loading.Dismiss();
            
                    this.InAction = false;
                });
            });
        });
    }

    public DeleteOfferType(pOfferTypeID: number): void {
        if (this.InAction) { return; }

        if (!this.OfferTypesByID[pOfferTypeID]) {
            this.HasSelectedOfferType  = false;
            this.WithFreeText          = false;
            this.SelectedOTHasLiveData = false;

            return;
        }

        if (pOfferTypeID == 1) {
            this.ShowAlert(
                this.ml.Text(
                     'CantDeletePrimary'
                    ,'Cannot Delete Primary Package'
                )
                ,this.ml.Text(
                     'CantDeletePrimaryPackage'
                    ,'Cannot Delete Primary Standard Rate Package'
                )
            );

            return;
        }

        if (this.OfferTypesByID[pOfferTypeID].HasLiveData) {
            this.ShowConfirmation(
                 this.ml.Text(
                     'WarningTitle'
                    ,'WARNING: Rate Package has Live Data'
                )
                ,this.ml.Text(
                     'WarningDelete'
                    ,'WARNING: Rate Package has Live Data! If you are sure you want to delete '
                      + 'this rate package, contact any channel provider to update your '
                      + 'connection settings ASAP. Delete this rate package?'
                )
                ,() => {
                    this.deleteOfferTypeInternal(pOfferTypeID);
                }
            );
        } else {
            this.deleteOfferTypeInternal(pOfferTypeID);
        }
    }

    public EditOfferTypeName() {
        if (this.InAction) { return; }

        if (!this.OfferTypesByID[this.SelectedOfferTypeID]) {
            this.HasSelectedOfferType = false;
            this.WithFreeText         = false;

            return;
        }

        let offerType: dmOfferType = this.OfferTypesByID[this.SelectedOfferTypeID];

        if (offerType.OfferType.OfferTypeAutoNameID > 0) { return; }

        if (this.SelectedOfferTypeName == '') {
            this.ShowAlert(
                 this.ml.Text('CantEditOfferTypeName' ,'Cannot Edit Rate Package Name')
                ,this.ml.Text('OfferTypeNameEmpty'    ,'Rate package name cannot be empty')
            );

            return;
        }

        this.InAction = true;

        let loading   = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let editNameParams = RQParam.PmsEditOfferTypeNameParams();
           
            editNameParams.HotelID       = this.Hotel.HotelID;
            editNameParams.OfferTypeID   = offerType.OfferType.OfferTypeID;
            editNameParams.OfferTypeName = this.SelectedOfferTypeName;
            editNameParams.LangID        = this.SelectedLangID;
           
            RQService.Pms.EditOfferTypeName(editNameParams).then((result) => {
                let response = result as any;
           
                if (response.HasErrorOrException) {
                    this.SelectedOfferTypeName = this.SelectedNameStored;
                } else {
                    this.SelectedNameStored    = this.SelectedOfferTypeName;
                }
           
                if (this.SelectedLangID == this.LangID) {
                    this.refreshOfferTypes(() => {
                        loading.Dismiss();
           
                        this.InAction = false;
                    });
                } else {
                    loading.Dismiss();
           
                    this.InAction = false;
                }
            });
        });
    }

    /* Non-Ref easy activation methods */
    public FocusEasyNonRef(): void {
        this.SelectOfferType(0);

        this.EarlyBirdSelected = false;
        this.EarlyBirdFocused  = false;
        this.EBShowAdvanced    = false;

        this.EasyNonRefFocused = true;
    }

    public SelectEasyNonRef(): void {
        if (!this.EasyNonRefFocused) { this.FocusEasyNonRef(); }

        this.EasyNonRefSelected = true;
    }

    public SelectSourceOfferType(pSourceOfferTypeID: number) {
        this.SelectedSourceOfferTypeID = pSourceOfferTypeID;
    }

    public SelectDiscountType(pDiscountTypeID: number) {
        this.DiscountTypeID = pDiscountTypeID;
    }

    public SelectIsSurcharge() {
        if (this.IsSurcharge) {
            this.IsSurchargeLabel = this.ml.Text('SurchargeAmount' ,'Surcharge Amount');
        } else {
            this.IsSurchargeLabel = this.ml.Text('DiscountAmount'  ,'Discount Amount');
        }
    }

    private deleteEasyNonRefOfferType(
         pOfferTypeID: number
        ,pPredicate:   (pWithError: boolean) => void
    ) {
        if (!this.EasyNonRefActive) { pPredicate(false); return; }
            
        let deleteParams = RQParam.PmsDeleteOfferTypeParams();
        
        deleteParams.HotelID     = this.Hotel.HotelID;
        deleteParams.OfferTypeID = this.EasyNonRefOfferTypeID;
        deleteParams.LangID      = this.LangID;
        
        RQService.Pms.DeleteOfferType(deleteParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pPredicate(true); return; }

            this.EasyNonRefActive      = false;
            this.EasyNonRefOfferTypeID = 0;

            pPredicate(false);
        });
    }

    public addEasyNonRefOfferType(
        pPredicate: (pWithError: boolean) => void
    ) {
        if (this.EasyNonRefActive) { pPredicate(true); return; }

        let addParams = RQParam.PmsNewOfferTypeAsDiscountOTAParams();
        
        addParams.HotelID                    = this.Hotel.HotelID;
        addParams.RackRatePaymentSchemeID    = 1;
        addParams.Credentials                = '';
        addParams.ReleaseDays                = 0;
        addParams.CancelConsumesAvailability = 0;
        addParams.OfferTypeName              = '';
        addParams.OfferTypeDescription       = '';
        addParams.OfferTypeAutoNameID        = 2;
        addParams.SourceOfferTypeID          = this.SelectedSourceOfferTypeID;
        addParams.DiscountTypeID             = this.DiscountTypeID;
        addParams.Surcharge                  = (this.IsSurcharge)
                                             ? this.Surcharge
                                             : (-1) * this.Surcharge;
        addParams.SourceMLOS                 = (this.SourceMLOS)        ? 1 : 0;
        addParams.SourceMaxStay              = (this.SourceMaxStay)     ? 1 : 0;
        addParams.SourceAdvanceDays          = 0;
        addParams.SourceNoArr                = (this.SourceNoDep)       ? 1 : 0;
        addParams.SourceNoDep                = (this.SourceNoDep)       ? 1 : 0;
        addParams.SourceMaxPersons           = 0;
        addParams.InitialiseAllotmentToZero  = 0;
        addParams.PackageLevelAdvanceDays    = 0;
        addParams.LangID                     = this.LangID;

        RQService.Pms.NewOfferTypeAsDiscountOTA(addParams).then((result) => {
            let response = result as any;
        
            if (response.HasErrorOrException) {
                pPredicate(true);
        
                return;
            }

            let newOfferTypeID: number = 0;

            let status = response.RQueryResult;

            if (
                (status.length > 0)
            &&  (status[0].ReturnValue)
            &&  (!isNaN(Number(status[0].ReturnValue)))
            ) {
                newOfferTypeID = Number(status[0].ReturnValue);
            }

            this.EasyNonRefActive      = true;
            this.EasyNonRefOfferTypeID = newOfferTypeID;

            pPredicate(false);
        });
    }

    public DeactivateEasyNonRef(): void {
        if ((this.InAction) || (!this.EasyNonRefActive)) { return; }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            this.deleteEasyNonRefOfferType(this.EasyNonRefOfferTypeID, (pWithError: boolean) => {
                if (!pWithError) {
                    if (this.SourceOfferTypes.length == 1) {
                        this.SelectSourceOfferType(
                            this.SourceOfferTypes[0].OfferType.OfferTypeID
                        );
                    } else {
                        this.SelectedSourceOfferTypeID = 0;
                    }

                    this.DiscountTypeID            = 0;

                    this.IsSurcharge               = false;
                    this.IsSurchargeLabel          = this.ml.Text(
                         'DiscountAmount'
                        ,'Discount Amount'
                    );

                    this.Surcharge                 = 0;
                    this.SourceMLOS                = true;
                    this.SourceMaxStay             = false;
                    this.SourceNoArr               = false;
                    this.SourceNoDep               = false;
                }

                loading.Dismiss();

                this.InAction = false;
            });
        });
    }

    public EditEasyNonRef(): void {
        if (this.InAction) { return; }

        if (this.SelectedSourceOfferTypeID == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'NoParentPackageSelected'
                    ,'No parent package selected'
                )
            );

            return;
        }

        if (this.Surcharge == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'SurchargeOrDiscountEmpty'
                    ,'Surcharge/Discount is empty'
                )
            );

            return;
        }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            if (this.EasyNonRefActive) {
                this.deleteEasyNonRefOfferType(this.EasyNonRefOfferTypeID, (pWithError: boolean) => {
                    if (pWithError) {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    }

                    this.addEasyNonRefOfferType((pWithError: boolean) => {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    });
                });
            } else {
                this.addEasyNonRefOfferType((pWithError: boolean) => {
                    loading.Dismiss();

                    this.InAction = false;

                    return;
                });
            }
        });
    }

    /* Early-Bird easy activation methods */
    public FocusEarlyBird(): void {
        this.SelectOfferType(0);

        this.EasyNonRefSelected = false;
        this.EasyNonRefFocused  = false;
        this.ShowAdvanced       = false;

        this.EarlyBirdFocused   = true;
    }

    public SelectEarlyBird(): void {
        if (!this.EarlyBirdFocused) { this.FocusEarlyBird(); }

        this.EarlyBirdSelected = true;
    }

    public EBSelectSourceOfferType(pEBSourceOfferTypeID: number) {
        this.EBSelectedSourceOfferTypeID = pEBSourceOfferTypeID;
    }

    public EBSelectDiscountType(pEBDiscountTypeID: number) {
        this.EBDiscountTypeID = pEBDiscountTypeID;
    }

    public EBSelectIsSurcharge() {
        if (this.EBIsSurcharge) {
            this.EBIsSurchargeLabel = this.ml.Text('SurchargeAmount' ,'Surcharge Amount');
        } else {
            this.EBIsSurchargeLabel = this.ml.Text('DiscountAmount'  ,'Discount Amount');
        }
    }

    private deleteEarlyBirdOfferType(
         pOfferTypeID: number
        ,pPredicate:   (pWithError: boolean) => void
    ) {
        if (!this.EarlyBirdActive) { pPredicate(false); return; }
            
        let deleteParams = RQParam.PmsDeleteOfferTypeParams();
        
        deleteParams.HotelID     = this.Hotel.HotelID;
        deleteParams.OfferTypeID = this.EarlyBirdOfferTypeID;
        deleteParams.LangID      = this.LangID;
        
        RQService.Pms.DeleteOfferType(deleteParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pPredicate(true); return; }

            this.EarlyBirdActive      = false;
            this.EarlyBirdOfferTypeID = 0;

            this.EarlyBirdAdvanceDays = 28;

            pPredicate(false);
        });
    }

    public addEarlyBirdOfferType(
        pPredicate: (pWithError: boolean) => void
    ) {
        if (this.EarlyBirdActive) { pPredicate(true); return; }

        let addParams = RQParam.PmsNewOfferTypeAsDiscountOTAParams();
        
        addParams.HotelID                    = this.Hotel.HotelID;
        addParams.RackRatePaymentSchemeID    = 1;
        addParams.Credentials                = '';
        addParams.ReleaseDays                = 0;
        addParams.CancelConsumesAvailability = 0;
        addParams.OfferTypeName              = '';
        addParams.OfferTypeDescription       = '';
        addParams.OfferTypeAutoNameID        = 5;
        addParams.SourceOfferTypeID          = this.EBSelectedSourceOfferTypeID;
        addParams.DiscountTypeID             = this.EBDiscountTypeID;
        addParams.Surcharge                  = (this.EBIsSurcharge)
                                             ? this.EBSurcharge
                                             : (-1) * this.EBSurcharge;
        addParams.SourceMLOS                 = (this.EBSourceMLOS)        ? 1 : 0;
        addParams.SourceMaxStay              = (this.EBSourceMaxStay)     ? 1 : 0;
        addParams.SourceAdvanceDays          = 0;
        addParams.SourceNoArr                = (this.EBSourceNoDep)       ? 1 : 0;
        addParams.SourceNoDep                = (this.EBSourceNoDep)       ? 1 : 0;
        addParams.SourceMaxPersons           = 0;
        addParams.InitialiseAllotmentToZero  = 0;
        addParams.PackageLevelAdvanceDays    = this.EarlyBirdAdvanceDays;
        addParams.LangID                     = this.LangID;

        RQService.Pms.NewOfferTypeAsDiscountOTA(addParams).then((result) => {
            let response = result as any;
        
            if (response.HasErrorOrException) {
                pPredicate(true);
        
                return;
            }

            let newOfferTypeID: number = 0;

            let status = response.RQueryResult;

            if (
                (status.length > 0)
            &&  (status[0].ReturnValue)
            &&  (!isNaN(Number(status[0].ReturnValue)))
            ) {
                newOfferTypeID = Number(status[0].ReturnValue);
            }

            this.EarlyBirdActive      = true;
            this.EarlyBirdOfferTypeID = newOfferTypeID;

            pPredicate(false);
        });
    }

    public DeactivateEarlyBird(): void {
        if ((this.InAction) || (!this.EarlyBirdActive)) { return; }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            this.deleteEarlyBirdOfferType(this.EarlyBirdOfferTypeID, (pWithError: boolean) => {
                if (!pWithError) {
                    if (this.EBSourceOfferTypes.length == 1) {
                        this.EBSelectSourceOfferType(
                            this.EBSourceOfferTypes[0].OfferType.OfferTypeID
                        );
                    } else {
                        this.EBSelectedSourceOfferTypeID = 0;
                    }

                    this.EBDiscountTypeID          = 0;

                    this.EBIsSurcharge             = false;
                    this.EBIsSurchargeLabel        = this.ml.Text(
                         'DiscountAmount'
                        ,'Discount Amount'
                    );

                    this.EBSurcharge               = 0;
                    this.EBSourceMLOS              = true;
                    this.EBSourceMaxStay           = false;
                    this.EBSourceNoArr             = false;
                    this.EBSourceNoDep             = false;
                }

                loading.Dismiss();

                this.InAction = false;
            });
        });
    }

    public EditEarlyBird(): void {
        if (this.InAction) { return; }

        if (this.EBSelectedSourceOfferTypeID == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'NoParentPackageSelected'
                    ,'No parent package selected'
                )
            );

            return;
        }

        if (this.EBSurcharge == 0) {
            this.ShowAlert(
                this.ml.Text(
                     'CantAddCustomPackage'
                    ,'Cannot Add Custom Package'
                )
                ,this.ml.Text(
                     'SurchargeOrDiscountEmpty'
                    ,'Surcharge/Discount is empty'
                )
            );

            return;
        }

        this.InAction = true;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            if (this.EarlyBirdActive) {
                this.deleteEarlyBirdOfferType(this.EarlyBirdOfferTypeID, (pWithError: boolean) => {
                    if (pWithError) {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    }

                    this.addEarlyBirdOfferType((pWithError: boolean) => {
                        loading.Dismiss();

                        this.InAction = false;

                        return;
                    });
                });
            } else {
                this.addEarlyBirdOfferType((pWithError: boolean) => {
                    loading.Dismiss();

                    this.InAction = false;

                    return;
                });
            }
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/offertypes/xv-offertypes.ts